var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "my-4", attrs: { "align-v": "start" } },
        [
          _c(
            "b-col",
            {
              staticClass:
                "d-flex flex-column align-items-center step-circle-container",
              attrs: { cols: "1" },
            },
            [_c("div", { staticClass: "step" }, [_vm._v("2")])]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "11" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "auto" } }, [
                    _c("h6", { staticClass: "mb-0 bold" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("direct-to-lender.participants.selectBroker")
                          ) +
                          ":\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.displayShowFavorites
                    ? _c("div", { staticClass: "ml-auto mr-3" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "clickable text-primary mr-2 tiny-font",
                            on: { click: _vm.toggleShowFavorites },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    !_vm.showFavorites
                                      ? "direct-to-lender.participants.showFavorites"
                                      : "direct-to-lender.participants.hideFavorites"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-input-group",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "form-control d-flex" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-1",
                                  attrs: { variant: "link", size: "sm" },
                                  on: { click: _vm.handleClear },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("global.words.clear")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.CO_BROKERING_LOADING_AGENTS
                                ? _c("inline-loader")
                                : _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        disabled: !_vm.agentSearchValid,
                                        variant: "primary",
                                        size: "sm",
                                      },
                                      on: { click: _vm.handleSearch },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("global.words.search")
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "b-input-group-addon",
                    {
                      staticClass: "prepend-with-input",
                      attrs: { id: "cobroker-select" },
                    },
                    [
                      _c("v-select-field", {
                        staticClass: "search-input",
                        attrs: {
                          placeholder: _vm.$t("global.doorr.brokerage"),
                          "no-options-text": _vm.$t(
                            "global.search.noMatchingOptions"
                          ),
                          label: "brokerageName",
                          "remove-duplicates-by": "brokerageId",
                          options: _vm.brokerages,
                          clearable: "",
                          autoscroll: false,
                          filterable: false,
                          "search-min-characters": 3,
                          "infinite-scroll-mode": "",
                          "loading-more-stop": !!_vm.allBrokeragesLoaded,
                          "loading-options":
                            _vm.loadingStates.searchingBrokerages ||
                            _vm.loadingStates.loadingMoreBrokerages,
                          loading: _vm.loadingStates.loadingBrokerages,
                          scenario: "cobrokering",
                        },
                        on: {
                          "option:selected": _vm.handleSelectBrokerage,
                          search: _vm.searchBrokerages,
                          clear: _vm.handleClearBrokerage,
                          "load-more": _vm.loadMoreBrokerages,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "search-input required agent-search-input",
                    attrs: {
                      id: "firstNameField",
                      placeholder: _vm.$t("account.givenName"),
                      value: _vm.currentData.agentFirstName,
                    },
                    on: {
                      input: function (val) {
                        return _vm.handleChangeAgentData(val, "agentFirstName")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "d-none", attrs: { for: "firstNameField" } },
                    [_vm._v(_vm._s(_vm.$t("account.givenName")))]
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "search-input required agent-search-input",
                    attrs: {
                      id: "lastNameField",
                      placeholder: _vm.$t("account.familyName"),
                      value: _vm.currentData.agentLastName,
                    },
                    on: {
                      input: function (val) {
                        return _vm.handleChangeAgentData(val, "agentLastName")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "d-none", attrs: { for: "lastNameField" } },
                    [_vm._v(_vm._s(_vm.$t("account.familyName")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showAgentsTable
                ? _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("co-broker-agents-search-table", {
                        ref: "searchTableRef",
                        attrs: {
                          "current-data": _vm.currentData,
                          "show-favorites": _vm.showFavorites,
                          "show-all-agents": _vm.showAllAgents,
                          "is-searching": _vm.isSearching,
                        },
                        on: {
                          "agent-selected": _vm.handleAgentSelected,
                          "display-show-favorites":
                            _vm.handleDisplayShowFavorites,
                          "show-all-agents": _vm.handleShowAllAgents,
                          "clear-favorites": _vm.handleClearFavorites,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c("b-col", { attrs: { offset: "1" } }, [
            !_vm.validations.agentFullNameIsValid
              ? _c("h6", { staticClass: "text-danger" }, [
                  _c("span", { staticClass: "text-grey text-uppercase" }, [
                    _vm._v(
                      _vm._s(_vm.$tc("global.words.note", 1)) + ":\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.validations.firstNameIsValid ||
                  _vm.validations.lastNameIsValid
                    ? _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "direct-to-lender.participants.nameIsRequired",
                                {
                                  name: !_vm.validations.firstNameIsValid
                                    ? _vm.$t("account.givenName")
                                    : _vm.$t("account.familyName"),
                                }
                              )
                            ) +
                            "\n        "
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "direct-to-lender.participants.firstAndLastRequired"
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }